module.exports = __webpack_public_path__ + "img/btn-read@3x.701900f8.png";